import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/styles.module.scss';
import buttonStyles from '../buttons/styles/styles.module.scss';

const FormButton = ({ value, disabled }) => {
  return <input type="submit" disabled={disabled} className={`${buttonStyles.submit} ${styles.submit}`} value={value} />;
};

FormButton.propTypes = {
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

FormButton.defaultProps = {
  disabled: false
};

export default FormButton;
